import { render, staticRenderFns } from "./TerminateAllocationButton.vue?vue&type=template&id=8a77c9d4"
import script from "./TerminateAllocationButton.vue?vue&type=script&lang=js"
export * from "./TerminateAllocationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports